<div class="custom-card shadow" [style.width]="width" [style.height]="height">
    <div class="card-titlebar">
        <div class="side-col w-{{getHeaderButtonsWidth()}}px">
            <a class="card-titlebar-button" *ngIf="showPreviousButton" (click)="onClickPrevious()">
                <i class="fas text-givt-purple fa-arrow-left"></i>
            </a>
        </div>
        <div class="middle-col">
            <p *ngIf="titleTranslationKey && titleTranslationKey?.length > 0" [translate]="titleTranslationKey"
                class="text-givt-purple text-center text-heavy-font p-0 m-0">
            </p>
        </div>
        <div class="side-col w-{{getHeaderButtonsWidth()}}px">
            <app-questionmark [title]="questionMarkTitle" *ngIf="questionMarkTitle" [text]="questionMarkText"
                class="card-titlebar-button">
            </app-questionmark>
            <app-questionmark-picture [title]="questionMarkPictureTitle" *ngIf="questionMarkPictureTitle"
                [text]="questionMarkPictureText" [picturePath]="questionMarkPicturePath"
                [pictureAlt]="questionMarkPictureAlt" class="card-titlebar-button">
            </app-questionmark-picture>
            <a class="card-titlebar-button" (click)="onClickClose()" *ngIf="showCloseButton">
                <i class="fas text-givt-purple fa-times"></i>
            </a>
        </div>
    </div>
    <div class="card-content">
        <div class="card-content-inner">
            <div class="{{iconBackgroundClass}} w-150px h-150px d-flex justify-content-center align-items-center shadow mb-5"
                *ngIf="icon">
                <i class="{{icon}} text-white"></i>
            </div>

            <div class="card-content-inner-content">
                <ng-content select="[body]">
                </ng-content>
            </div>

            <ng-content select="[bottom]">
            </ng-content>
        </div>
    </div>
</div>